export default "/images/plus.svg?38c972416f9360baad54d5f359efb8d3";